// Studio editing history lives here, outside the component tree, so a panel remount does not lose it: React state is SEEDED from here and WRITTEN THROUGH to here. Keyed by base pog id; cleared only explicitly; nothing outlives a page load.
import type { StudioHistory } from "../domain/studioHistory";

const HISTORY_BY_KEY = new Map<string, StudioHistory>();

export const studioHistoryKey = (basePogId: number | null | undefined): string | null =>
  basePogId === null || basePogId === undefined ? null : `base-pog:${basePogId}`;

export const getStudioHistory = (key: string | null): StudioHistory | undefined =>
  key === null ? undefined : HISTORY_BY_KEY.get(key);

export const setStudioHistory = (key: string | null, history: StudioHistory): void => {
  if (key === null) return;
  HISTORY_BY_KEY.set(key, history);
};

export const clearStudioHistory = (key: string | null): void => {
  if (key === null) return;
  HISTORY_BY_KEY.delete(key);
};

export const resetStudioHistoryStore = (): void => {
  HISTORY_BY_KEY.clear();
};
